import { AspectRatioType } from "@/types";

import { PresetType } from "./types";

const getPresetAspectRatioFields = (
  h: number,
  w: number,
): Pick<PresetType, "aspectRatio" | "aspectRatioLabel"> => ({
  aspectRatioLabel: `${h}:${w}`,
  aspectRatio: h / w,
});

export const ASPECT_RATIO_MAP: Record<
  AspectRatioType,
  Omit<PresetType, "dimensions">
> = {
  SQUARE: { label: "Square", ...getPresetAspectRatioFields(1, 1) },
  SQUARE_HD: { label: "Square HD", ...getPresetAspectRatioFields(1, 1) },
  LANDSCAPE_3_2: { label: "Landscape", ...getPresetAspectRatioFields(3, 2) },
  LANDSCAPE_4_3: { label: "Landscape", ...getPresetAspectRatioFields(4, 3) },
  LANDSCAPE_5_4: { label: "Landscape", ...getPresetAspectRatioFields(5, 4) },
  LANDSCAPE_16_9: { label: "Landscape", ...getPresetAspectRatioFields(16, 9) },
  LANDSCAPE_21_9: { label: "Landscape", ...getPresetAspectRatioFields(21, 9) },
  LANDSCAPE_2_1: { label: "Panorama", ...getPresetAspectRatioFields(2, 1) },
  LANDSCAPE_4_1: { label: "Ultra-Wide", ...getPresetAspectRatioFields(4, 1) },
  LANDSCAPE_8_1: { label: "Ultra-Wide", ...getPresetAspectRatioFields(8, 1) },
  PORTRAIT_2_3: { label: "Portrait", ...getPresetAspectRatioFields(2, 3) },
  PORTRAIT_3_4: { label: "Portrait", ...getPresetAspectRatioFields(3, 4) },
  PORTRAIT_4_5: { label: "Portrait", ...getPresetAspectRatioFields(4, 5) },
  PORTRAIT_9_16: { label: "Portrait", ...getPresetAspectRatioFields(9, 16) },
  PORTRAIT_9_21: { label: "Portrait", ...getPresetAspectRatioFields(9, 21) },
  PORTRAIT_1_4: { label: "Ultra-Tall", ...getPresetAspectRatioFields(1, 4) },
  PORTRAIT_1_8: { label: "Ultra-Tall", ...getPresetAspectRatioFields(1, 8) },
};

export const SORTED_ASPECT_RATIO_TYPES = Object.keys(
  ASPECT_RATIO_MAP,
) as AspectRatioType[];
